export default __webpack_public_path__ + "static/media/741hz-toxin-cleanse.4bf7e3c6.ogg";